export default {
  brand: {
    name: 'FUHAI International',
    fullName: 'Fuhai Tonda International Machine (Suzhou) Co., Ltd',
    description: 'A leading manufacturer of agricultural machinery, specializing in tractors and farming equipment. We provide innovative solutions for modern agriculture, integrating R&D, production, sales and service.',
    address: 'Room 210, Building 1, Shahu Science and Technology Park, No.183, Tinglan Lane, Suzhou Industrial Park, P.R.China',
    productionBase: 'Fangcheng Sub-district, Fangzi District, High-tech Zone, Weifang City, Shandong Province, P.R.China',
    phone: '+86 15206211582',
    email: 'sales@fuhai-intl.com',
    addressLabel: 'Address: ',
    productionBaseLabel: 'Production Base: '
  },
  copyright: 'Copyright©2016 All rights reserved, Fuhai Tonda International Machine (Suzhou) Co., Ltd',
  language: 'English',
  banner: {
    company_name: 'Fuhai Tonda International machine (suzhou) Co.,Ltd',
    tagline1: 'Innovate Fuhai ',
    tagline2: 'Serve the Global',
    tagline3: 'Technology is transforming the future of agriculture'
  },
  footer: {
    followUs: 'Follow Us'
  },
  social: {
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    twitter: 'Twitter'
  }
}; 